import React, { ReactElement } from 'react'
import { Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './intro.css'
import useWindowSize from '../../utils/useWindowSize'
import { SHEET_SOURCE } from '../../constants'
import { ImageConfiguration } from '../../../../typings'
import ButtonFullWidth from '../../components/ButtonFullWidth'
import { useAppSelector } from '../../store/hooks'
import { selectSheetSource } from '../../store/slices/sheetsSlice'
import { ContainerGeneration } from './ContainerGeneration'
import { isUserTypeAgnosticIntroEnabled } from '../../utils/features'

type IntroPageProps = {
  id: string
  images: ImageConfiguration
  title: string
  firstIcon: ReactElement
  firstSubtitle: string
  secondIcon: ReactElement
  secondSubtitle: string
  showPrivacyLink?: boolean
}
type RenderIntroPageProps = {
  item: IntroPageProps
  goToPrivacyScreen: () => void
  onClickConfirmButton: () => void
}

export const IntroPage = ({
  item,
  goToPrivacyScreen,
  onClickConfirmButton,
}: RenderIntroPageProps) => {
  const { isSmallerScreen } = useWindowSize()
  const sheetSource = useAppSelector(selectSheetSource)
  const isAgnosticIntroEnabled = isUserTypeAgnosticIntroEnabled()
  const messageId =
    sheetSource === SHEET_SOURCE.CREATE_GROUP_BUTTON || isAgnosticIntroEnabled
      ? 'create.intro.startPooling'
      : 'create.intro.contribute'
  return (
    <div className={styles.newIntroContentContainer} data-testid={item.id}>
      <ContainerGeneration
        item={item}
        goToPrivacyScreen={goToPrivacyScreen}
        isSmallerScreen={isSmallerScreen}
      >
        <Row noGutters={true} className={styles.poolButton}>
          <ButtonFullWidth
            data-testid="confirmButton"
            onClick={onClickConfirmButton}
          >
            <Message id={messageId} />
          </ButtonFullWidth>
        </Row>
      </ContainerGeneration>
    </div>
  )
}
